export default "__VITE_ASSET__84lRPzvC__"